export default __webpack_public_path__ + "static/media/ava2.93771b5e.png";